import React, { useState, useCallback, useEffect } from "react"
import PropTypes from "prop-types"
import {
  Button,
  Grid,
  Typography,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableSortLabel,
  TablePagination,
  Select,
  MenuItem,
  Autocomplete,
  TextField,
} from "@mui/material"
import TableCell, { tableCellClasses } from "@mui/material/TableCell"
import { makeStyles, useTheme } from "@mui/styles"
import { ThemeProvider, createTheme } from "@mui/material/styles"
import { GetApp } from "@mui/icons-material"
import { useApp } from "../../AppProvider"
import XLSX from "xlsx-js-style"
import { getStatisticsDetail, getStatisticsGrouped } from "./services/api"
import StatisticsFilter from "./components/statisticsFilter"
import * as moment from "moment"
import "moment/locale/es"
import FilterIconV2 from "./../../assets/filterIcon.svg"
import {
  tableStyles,
  StyledTableRow,
  StyledTableCell,
} from "../../helpers/styles/sectionTable.style"
import "./style.css"
import { getAllActiveBusiness } from "../dashboard/services/api"
import styled, { keyframes } from "styled-components"
import PrimaryButton from "../../components/PrimaryButton/PrimaryButton"
import DeactivatedButton from "../../components/DeactivatedButton/DeactivatedButton"
import { ROLES } from "../sidebar/constants"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"

const gradient = keyframes`
0% { background-position: -250px 0; }
100% { background-position: 250px 0; }
`

const Gradient = styled.p`
  height: 12px;
  width: 60%;
  border-radius: 8px;
  background: linear-gradient(to right, #eee 20%, #ddd 50%, #eee 80%);
  background-size: 500px 100px;
  animation-name: ${gradient};
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
`

const useStyles = makeStyles(() => ({
  tableTitle: {
    marginLeft: 5,
    fontFamily: "Ubuntu !important",
    fontStyle: "normal !important",
    fontWeight: "700 !important",
    fontSize: "25px !important",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    color: "#363636",
    marginBottom: "40px",
  },
  tableCellText: {
    fontSize: "18px !important",
    fontWeight: "700 !important",
    fontFamily: "Ubuntu !important",
    marginLeft: "-18px !important",
  },
  clickableCellText: {
    color: "#0957A0",
  },
  campaignMenuItem: {
    height: 32,
    textAlign: "center !important",
    "&:hover": {
      background: "rgba(9, 87, 160, 0.15) !important",
      color: "#0957A0",
    },
  },
  campaignMenuItemText: {
    fontSize: 12,
    fontFamily: "Ubuntu",
    color: "inherit",
  },
  paginationLabel: {
    fontFamily: "Ubuntu",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    color: "rgba(115, 115, 115, 1)",
    "@media screen and (max-width: 1350px)": {
      fontSize: "12px !important",
    },
  },
  disabledDownload: {
    color: "white !important",
    backgroundColor: "#CFD8E0 !important",
  },
  tableBodyContainer: {
    padding: 0,
    "@media screen and (max-width: 1350px)": {
      height: "2vh",
    },
  },
  tableBodyContent: {
    textAlign: "center !important",
    "&:first-child": {
      paddingLeft: "4% !important",
      textAlign: "left !important",
    },
    "&.autoMargin:first-child": {
      margin: "0px !important",
    },
  },
  autoMargin: {
    margin: "auto !important",
  },
  HeadSectionContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
}))

const columOrderToShow = [
  {
    name: "date",
    length: false,
    link: false,
  },
  {
    name: "title",
    length: false,
    link: false,
  },
  {
    name: "send",
    length: false,
    link: false,
  },
]

/// FUNCION ENCARGADA DE DETERMIAR EL ATRIBUTO POR EL CUAL SE HACE EL ORDENADO
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1
  }
  if (b[orderBy] > a[orderBy]) {
    return 1
  }
  return 0
}
/// FUNCION QUE DETERMINA EL ORDEN EN EL QUE SE DEBE ORDENAR

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) {
      return order
    }
    return a[1] - b[1]
  })
  return stabilizedThis.map((el) => el[0])
}

function EnhancedTableHead(props) {
  const theme = createTheme({
    components: {
      MuiTableSortLabel: {
        styleOverrides: {
          icon: {
            color: "white !important",
            stroke: "white !important",
            strokeWidth: 1.5,
          },
        },
      },
    },
  })

  const classes = tableStyles()

  const { order, orderBy, onRequestSort, headCells } = props
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property)
  }

  const encabezadolistado = {
    height: "24px",
    fontFamily: "Ubuntu",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "20px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    color: "#FFFFFF",
    textAlign: "center",
  }

  return (
    <TableHead
      sx={{
        color: "white !important",
        height: 63,
        borderRadius: "8px 8px 0px 0px",
        background: "#A3A3A3",
        boxShadow: "none",
      }}
    >
      <StyledTableRow>
        {headCells.map((headCell) => (
          <StyledTableCell
            key={headCell.id}
            sortDirection={orderBy === headCell.id ? order : false}
            style={encabezadolistado}
            colSpan={headCell.col}
            sx={{ textAlign: headCell.textAlign }}
          >
            <ThemeProvider theme={theme}>
              <TableSortLabel
                disabled={headCell.id === "dateStamp" ? false : true}
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
                style={{ color: "white", fontWeight: "700" }}
                sx={{ paddingLeft: headCell.marginLeft }}
              >
                {headCell.label}
              </TableSortLabel>
            </ThemeProvider>
          </StyledTableCell>
        ))}
      </StyledTableRow>
    </TableHead>
  )
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  headCells: PropTypes.array.isRequired,
}

const Statistics = () => {
  const classes = useStyles()
  const theme = useTheme()
  const { currentUser } = useApp()
  const [campaignList, setCampaignList] = useState([])
  const [filteredCampaignList, setFilteredCampaignList] = useState(campaignList)
  const [totalElements, setTotalElements] = useState(0)
  const [onLoad, setOnLoad] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  /*ENHANCED HEAD*/
  const [order, setOrder] = useState("asc")
  const [orderBy, setOrderBy] = useState("dateStamp")
  /*TABLE PAGINATION*/
  const [rowsPerPage, setRowsPerPage] = useState(5)
  const [page, setPage] = useState(0)
  const [showFilter, setShowFilter] = useState(false)
  const [business, setBusiness] = useState(0)
  const [businessList, setBusinessList] = useState([])

  const loadingColumns = [1, 2, 3]

  function getComparator(order, orderBy) {
    const isNumeric = headCells.find((headCell) => headCell.id == orderBy)
    if (isNumeric.numeric === true) {
      return order === "desc"
        ? (a, b) => -descendingComparator(a, b, orderBy)
        : (a, b) => descendingComparator(a, b, orderBy)
    } else {
      return order === "desc"
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy)
    }
  }

  const [headCells, setHeadCells] = useState([
    {
      id: "dateStamp",
      label: "Fecha de envío",
      numeric: false,
      col: 1,
      textAlign: "left !important",
      marginLeft: "48px !important",
    },
    {
      id: "productLabel",
      label: "Producto",
      numeric: false,
      col: 1,
      textAlign: "left !important",
      marginLeft: "0px",
    },
    {
      id: "statusLabel",
      label: "Estado",
      numeric: false,
      col: 3,
      textAlign: "center",
      marginLeft: "0px",
    },
  ])

  const [searchRange, setSearchRange] = useState({
    initDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
    limitDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
  })

  const fetchStatisticsInit = useCallback(async (range, business) => {
    setIsLoading(true)
    const resStatistics = await getStatisticsGrouped({
      ...range,
      businessId: business,
      page: 1,
      limit: 5,
    })
    setCampaignList(resStatistics.data)
    if (resStatistics.data.length > 0) {
      setTotalElements(parseInt(resStatistics.data[0].totalcount))
    } else {
      setTotalElements(0)
    }
    setOnLoad(false)
    setIsLoading(false)
    setPage(0)
    setRowsPerPage(5)
  }, [])

  const fetchStatistics = useCallback(async (range, business, page, rowsPerPage) => {
    setIsLoading(true)
    const resStatistics = await getStatisticsGrouped({
      ...range,
      businessId: business,
      page: page + 1,
      limit: rowsPerPage,
    })
    setCampaignList(resStatistics.data)
    if (resStatistics.data.length > 0) {
      setTotalElements(parseInt(resStatistics.data[0].totalcount))
    } else {
      setTotalElements(0)
    }
    setOnLoad(false)
    setIsLoading(false)
  }, [])

  const buildResults = (
    data,
    { initDate, limitDate },
    businessName,
    business
  ) => {
    let nBook = XLSX.utils.book_new()
    console.log("business", businessName)
    const business_name = businessName
      .toLowerCase()
      .replace(
        /(?<g>^.)(?<h>.*)/,
        (match, p1, p2) => `${p1.toUpperCase()}${p2}`
      )
    let carga_headers = []

    if (currentUser.role == ROLES.SUPER && business == 0) {
      carga_headers = [
        [" "],
        [],
        [],
        ["", "", "", "", "ESTATUS DEL ENVÍO DE MENSAJES SMS"],
        [
          "FECHA",
          "EMPRESA",
          "PRODUCTO",
          "UID",
          "OPERADORA",
          "ENVIADOS",
          "EXITOSOS",
          "FALLIDOS",
        ],
      ]
    } else {
      carga_headers = [
        [`EMPRESA: ${business_name}`],
        [],
        [],
        ["", "", "", "ESTATUS DEL ENVÍO DE MENSAJES SMS"],
        ["FECHA", "PRODUCTO", "UID", "OPERADORA", "ENVIADOS", "EXITOSOS", "FALLIDOS"],
      ]
    }
    const ws = XLSX.utils.aoa_to_sheet(carga_headers, { cellStyles: true })
    let wscols = [
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
    ]

    let merge = []
    if (business != 0) {
      merge = [{ s: { r: 3, c: 3 }, e: { r: 3, c: 5 } }]
    } else {
      merge = [{ s: { r: 3, c: 4 }, e: { r: 3, c: 6 } }]
    }
    ws["!merges"] = merge
    ws["!cols"] = wscols
    if (business != 0) {
      ws["A1"].s = {
        font: { color: { rgb: "ffffff" }, bold: true, name: "arial", sz: 10 },
        fill: { pattern: "solid", fgColor: { rgb: "3c78d8" } },
      }
    }
    if (business == 0) {
      ws["E4"].s = {
        alignment: { horizontal: "center" },
        font: { bold: true, name: "arial", sz: 10 },
      }
    } else {
      ws["D4"].s = {
        alignment: { horizontal: "center" },
        font: { bold: true, name: "arial", sz: 10 },
      }
    }
    ws["A5"].s = {
      alignment: { horizontal: "center" },
      font: { bold: true, name: "arial", sz: 10 },
      fill: { pattern: "solid", fgColor: { rgb: "efefef" } },
      border: {
        top: { style: "thin", color: { rgb: "BFBFBF" } },
        bottom: { style: "thin", color: { rgb: "BFBFBF" } },
        left: { style: "thin", color: { rgb: "BFBFBF" } },
        right: { style: "thin", color: { rgb: "BFBFBF" } },
      },
    }
    ws["B5"].s = {
      alignment: { horizontal: "center" },
      font: { bold: true, name: "arial", sz: 10 },
      fill: { pattern: "solid", fgColor: { rgb: "efefef" } },
      border: {
        top: { style: "thin", color: { rgb: "BFBFBF" } },
        bottom: { style: "thin", color: { rgb: "BFBFBF" } },
        left: { style: "thin", color: { rgb: "BFBFBF" } },
        right: { style: "thin", color: { rgb: "BFBFBF" } },
      },
    }
    ws["C5"].s = {
      alignment: { horizontal: "center" },
      font: { bold: true, name: "arial", sz: 10 },
      fill: { pattern: "solid", fgColor: { rgb: "efefef" } },
      border: {
        top: { style: "thin", color: { rgb: "BFBFBF" } },
        bottom: { style: "thin", color: { rgb: "BFBFBF" } },
        left: { style: "thin", color: { rgb: "BFBFBF" } },
        right: { style: "thin", color: { rgb: "BFBFBF" } },
      },
    }
    ws["D5"].s = {
      alignment: { horizontal: "center" },
      font: { bold: true, name: "arial", sz: 10 },
      fill:
        business == 0
          ? { pattern: "solid", fgColor: { rgb: "efefef" } }
          : { pattern: "solid", fgColor: { rgb: "c9daf8" } },
      border: {
        top: { style: "thin", color: { rgb: "BFBFBF" } },
        bottom: { style: "thin", color: { rgb: "BFBFBF" } },
        left: { style: "thin", color: { rgb: "BFBFBF" } },
        right: { style: "thin", color: { rgb: "BFBFBF" } },
      },
    }
    ws["E5"].s = {
      alignment: { horizontal: "center" },
      font: { bold: true, name: "arial", sz: 10 },
      fill: { pattern: "solid", fgColor: { rgb: "c9daf8" } },
      border: {
        top: { style: "thin", color: { rgb: "BFBFBF" } },
        bottom: { style: "thin", color: { rgb: "BFBFBF" } },
        left: { style: "thin", color: { rgb: "BFBFBF" } },
        right: { style: "thin", color: { rgb: "BFBFBF" } },
      },
    }
    ws["F5"].s = {
      alignment: { horizontal: "center" },
      font: { bold: true, name: "arial", sz: 10 },
      fill: { pattern: "solid", fgColor: { rgb: "c9daf8" } },
      border: {
        top: { style: "thin", color: { rgb: "BFBFBF" } },
        bottom: { style: "thin", color: { rgb: "BFBFBF" } },
        left: { style: "thin", color: { rgb: "BFBFBF" } },
        right: { style: "thin", color: { rgb: "BFBFBF" } },
      },
    }
    ws["G5"].s = {
        alignment: { horizontal: "center" },
        font: { bold: true, name: "arial", sz: 10 },
        fill: { pattern: "solid", fgColor: { rgb: "c9daf8" } },
        border: {
          top: { style: "thin", color: { rgb: "BFBFBF" } },
          bottom: { style: "thin", color: { rgb: "BFBFBF" } },
          left: { style: "thin", color: { rgb: "BFBFBF" } },
          right: { style: "thin", color: { rgb: "BFBFBF" } },
        },
      }

    if (business == 0) {
      ws["H5"].s = {
        alignment: { horizontal: "center" },
        font: { bold: true, name: "arial", sz: 10 },
        fill: { pattern: "solid", fgColor: { rgb: "c9daf8" } },
        border: {
          top: { style: "thin", color: { rgb: "BFBFBF" } },
          bottom: { style: "thin", color: { rgb: "BFBFBF" } },
          left: { style: "thin", color: { rgb: "BFBFBF" } },
          right: { style: "thin", color: { rgb: "BFBFBF" } },
        },
      }
    }

    if (currentUser.role == ROLES.SUPER && business == 0) {
      XLSX.utils.sheet_add_aoa(
        ws,
        data.map(
          ({
            date,
            business_name,
            product_nombre,
            campaign_message_carrier,
            solicitados,
            enviados,
            fallidos,
            product_gateway_id
          }) => [
            moment(date).utcOffset("+0400").format("L"),
            business_name == null ? " " : business_name,
            product_nombre,
            product_gateway_id ? product_gateway_id : " ",
            campaign_message_carrier,
            solicitados,
            enviados,
            fallidos,
          ]
        ),
        { origin: "A6", cellStyles: true }
      )
    } else {
      XLSX.utils.sheet_add_aoa(
        ws,
        data.map(
          ({
            date,
            product_nombre,
            campaign_message_carrier,
            solicitados,
            enviados,
            fallidos,
            product_gateway_id
          }) => [
            moment(date).utcOffset("+0400").format("L"),
            product_nombre,
            product_gateway_id ? product_gateway_id : " ",
            campaign_message_carrier,
            solicitados,
            enviados,
            fallidos,
          ]
        ),
        { origin: "A6", cellStyles: true }
      )
    }
    const lengthCells = business == 0 ? 7 : 6
    for (let i = 0; i < data.length; i++) {
      for (let j = 0; j <= lengthCells; j++) {
        console.log("cell", j)
        ws[XLSX.utils.encode_cell({ r: 5 + i, c: j })].s = {
          alignment: { horizontal: "center" },
          font: { name: "arial", sz: 10 },
        }
      }
    }
    XLSX.utils.book_append_sheet(
      nBook,
      ws,
      business == 0
        ? `sms_${initDate}_${limitDate}`
        : `${business_name.substring(0, 6)}_(${initDate}_${limitDate})`
    )
    XLSX.writeFile(
      nBook,
      business == 0
        ? `reporte_sms_${initDate}_${limitDate}.xlsx`
        : `reporte_sms_${business_name}_(${initDate}_${limitDate}).xlsx`,
      { type: "buffer", bookType: "xlsx", cellStyles: true }
    )
  }

  const handleBuildResults = async (range, businessName, business) => {
    const resStatistics = await getStatisticsDetail({
      ...range,
      businessId: business,
    })
    buildResults(resStatistics.data, range, businessName, business)
  }

  useEffect(async () => {
    if (currentUser.role == ROLES.SUPER) {
      fetchBusinessList()
    } else {
      setBusiness(currentUser.usuarioEmpresas[0].id)
    }
  }, [])

  const fetchBusinessList = async () => {
    try {
      const response = await getAllActiveBusiness()
      setBusinessList([{ id: 0, razonSocial: "Todas" }].concat(response.data))
    } catch (error) {
      console.log("Error fetching business list", error)
    }
  }

  useEffect(() => {
    setOnLoad(true)
    fetchStatisticsInit(searchRange, business)
  }, [searchRange])

  useEffect(() => {
    checkBusiness(business)
    setOnLoad(true)
    fetchStatisticsInit(searchRange, business)
  }, [business])

  const checkBusiness = (business) => {
    if (business == 0) {
      const auxHeadCells = headCells
      auxHeadCells.splice(1, 0, {
        id: "businessLabel",
        label: "Empresa",
        numeric: false,
        col: 1,
        textAlign: "left !important",
        marginLeft: "0px",
      })
      setHeadCells(auxHeadCells)
    } else {
      const auxHeadCells = headCells.filter(
        (headCell) => headCell.id !== "businessLabel"
      )
      setHeadCells(auxHeadCells)
    }
  }

  useEffect(() => {
    setFilteredCampaignList(campaignList)
  }, [campaignList])

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc"
    setOrder(isAsc ? "desc" : "asc")
    setOrderBy(property)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
    fetchStatistics(searchRange, business, newPage, rowsPerPage)
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
    fetchStatistics(searchRange, business, 0, parseInt(event.target.value, 10))
  }

  return (
    <React.Fragment>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        sx={{ marginBottom: "24px" }}
      >
        <Grid item xs={12} sm={12} md={12}>
          <div className={classes.HeadSectionContainer}>
            <div>
              <Typography variant="h3" className={classes.tableTitle}>
                Consulta de reporte
              </Typography>
              <Typography
                sx={{
                  fontSize: "13px !important",
                  padding: "16px 0px 0px 0px",
                  fontFamily: "Ubuntu !important",
                  color: "#363636",
                  margin: "0px !important",
                  "& p": {
                    margin: 0,
                  },
                }}
              >
                Aquí podrás <b> visualizar el estado </b> de tus envíos de{" "}
                <b>mensajes vía SMS</b>
              </Typography>
            </div>
            {currentUser.role == ROLES.SUPER && (
              <Autocomplete
                id="combo-box-demo"
                options={businessList}
                ListboxProps={{ style: { maxHeight: "10.8rem" } }}
                getOptionLabel={(option) => option.razonSocial}
                clearOnBlur
                selectOnFocus
                disableClearable
                freeSolo
                onChange={(event, newValue) => {
                  setBusiness(newValue.id)
                }}
                noOptionsText="No se han encontrado opciones"
                forcePopupIcon={true}
                popupIcon={
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "8px 8px 8px 8px",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="9"
                      viewBox="0 0 14 9"
                      fill="none"
                    >
                      <path
                        d="M6.87433 8.99344C6.599 8.96361 6.33864 8.83861 6.12911 8.63587L0.501909 3.21448C0.218731 2.95942 0.0398573 2.58607 0.00584532 2.18C-0.0279863 1.77389 0.0860324 1.36991 0.322107 1.06001C0.557994 0.750123 0.895737 0.561042 1.25782 0.536038C1.62006 0.511037 1.97577 0.652222 2.24378 0.927439L7 5.51126L11.7562 0.927439C12.0243 0.652427 12.38 0.511244 12.7422 0.536248C13.1042 0.561039 13.442 0.750123 13.6779 1.06001C13.914 1.36989 14.028 1.77409 13.9942 2.18021C13.9601 2.58632 13.7813 2.95943 13.4981 3.21448L7.87089 8.63587C7.59557 8.90205 7.23592 9.03105 6.87446 8.99365L6.87433 8.99344Z"
                        fill={"rgba(0, 0, 0, 0.54)"}
                      />
                    </svg>
                  </div>
                }
                value={
                  businessList.length > 0
                    ? businessList.find((b) => b.id == business)
                    : { id: 0, razonSocial: "Todas" }
                }
                blurOnSelect={true}
                sx={{
                  "& label": {
                    color: "rgba(0, 0, 0, 0.87)",
                    fontFamily: "Ubuntu",
                    fontStyle: "normal",
                    fontWeight: "400",
                    fontSize: "13px",
                    lineHeight: "24px",
                    letterSpacing: "0.15px",
                  },
                  height: "30px",
                  marginBottom: "10px",
                  width: "229px",
                  marginLeft: 6.5,
                }}
                renderInput={(params) => (
                  <TextField
                    id="vempresa"
                    {...params}
                    label="Empresa"
                    size="small"
                    InputProps={{
                      ...params.InputProps,
                      style: { fontSize: "13px" },
                    }}
                  />
                )}
              />
              // <Select
              //   id="business-input"
              //   sx={{
              //     width: "219px",
              //     height: "30px",
              //     margin: "0px 33px 0px 0px",
              //   }}
              //   className={classes.select}
              //   value={business}
              //   IconComponent={ExpandMoreIcon}
              //   MenuProps={{
              //     style: {
              //       maxHeight: "267px",
              //       marginTop: "0px",
              //       paddingTop: "0px",
              //       maxWidth: "219px",
              //     },
              //   }}
              //   onChange={(e) => {
              //     if (isLoading) return
              //     setBusiness(e.target.value)
              //   }}
              // >
              //   <MenuItem
              //     key={0}
              //     value={0}
              //     sx={{
              //       color: "black",
              //       fontSize: "13px",
              //       fontWeight: "400",
              //       lineHeight: "24px",
              //       fontFamily: "Ubuntu !important",
              //     }}
              //   >
              //     Todas
              //   </MenuItem>
              //   {businessList.map((b) => (
              //     <MenuItem
              //       key={b.id}
              //       value={b.id}
              //       sx={{
              //         color: "black",
              //         fontSize: "13px",
              //         fontWeight: "400",
              //         lineHeight: "24px",
              //         fontFamily: "Ubuntu !important",
              //       }}
              //     >
              //       {b.razonSocial}
              //     </MenuItem>
              //   ))}
              // </Select>
            )}
          </div>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        sx={{ marginBottom: "14px" }}
      >
        <Grid item sx={{ marginRight: "21px" }}>
          <Button
            onClick={() => {
              setShowFilter(true)
            }}
            startIcon={<img src={FilterIconV2} alt="filter_icon_v2" />}
            sx={{
              borderRadius: "2px",
              backgroundColor: "white",
              borderStyle: "none",
              fontFamily: "Ubuntu",
              fontWeight: "400",
              letterSpacing: "0.15px",
              color: "rgba(78, 85, 137, 1) !important",
              textTransform: "none",
            }}
          >
            Filtro
          </Button>
        </Grid>
        <Grid item>
          {filteredCampaignList.length !== 0 && !isLoading ? (
            <PrimaryButton
              text="Descargar"
              margin="0px 33px 0px 0px"
              action={() => {
                handleBuildResults(
                  searchRange,
                  currentUser.role == ROLES.SUPER
                    ? business == 0
                      ? ""
                      : businessList.filter((b) => b.id == business)[0]
                          .razonSocial
                    : currentUser.usuarioEmpresas[0].razonSocial,
                  business
                )
              }}
              height="40px"
              fontSize="14"
              lineHeight="28"
              startIcon={<GetApp sx={{ color: "#FFFFFF" }} />}
              noShadow={true}
            />
          ) : (
            <DeactivatedButton
              text="Descargar"
              margin="0px 33px 0px 0px"
              action={() => {
                handleBuildResults(
                  searchRange,
                  currentUser.role == ROLES.SUPER
                    ? business == 0
                      ? ""
                      : businessList.filter((b) => b.id == business)[0]
                          .razonSocial
                    : currentUser.usuarioEmpresas[0].razonSocial,
                  business
                )
              }}
              height="40px"
              fontSize="14"
              lineHeight="28"
              startIcon={<GetApp sx={{ color: "#FFFFFF" }} />}
              noShadow={true}
            />
          )}
          {/* <Button
            disabled={filteredCampaignList.length === 0}
            onClick={() => {
              handleBuildResults(
                searchRange,
                currentUser.usuarioEmpresas[0].razonSocial
              )
            }}
            startIcon={<GetApp />}
            classes={{
              disabled: classes.disabledDownload,
            }}
            sx={{
              borderRadius: "6px",
              backgroundColor: "rgba(78, 85, 137, 1)",
              borderStyle: "none",
              fontFamily: "Ubuntu",
              fontWeight: "400",
              letterSpacing: "0.15px",
              color: "white",
              textTransform: "none",
              marginRight: 5,
              "&:hover": {
                backgroundColor: "rgba(78, 85, 137, 1)",
                color: "white",
              },
            }}
          >
            Descargar
          </Button> */}
        </Grid>
      </Grid>
      <TableContainer
        component={Paper}
        sx={{ boxShadow: "0px 0px 4px rgb(0 0 0 / 25%) !important" }}
      >
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <EnhancedTableHead
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            headCells={headCells}
          />
          <TableBody sx={{ borderBottom: "1px solid rgba(232, 232, 232, 1)" }}>
            {filteredCampaignList.length !== 0 && !isLoading ? (
              <StyledTableRow>
                <StyledTableCell component="th" scope="row"></StyledTableCell>
                <StyledTableCell
                  component="th"
                  scope="row"
                  align="center"
                ></StyledTableCell>
                {business == 0 ? (
                  <StyledTableCell
                    component="th"
                    scope="row"
                    align="center"
                  ></StyledTableCell>
                ) : (
                  <React.Fragment />
                )}
                <StyledTableCell
                  component="th"
                  scope="row"
                  align="center"
                  sx={{ fontWeight: "400 !important" }}
                >
                  {"Enviados"}
                </StyledTableCell>
                <StyledTableCell
                  component="th"
                  scope="row"
                  align="center"
                  sx={{ fontWeight: "400 !important" }}
                >
                  {"Exitosos"}
                </StyledTableCell>
                <StyledTableCell
                  component="th"
                  scope="row"
                  align="center"
                  sx={{ fontWeight: "400 !important" }}
                >
                  {"Fallidos"}
                </StyledTableCell>
              </StyledTableRow>
            ) : (
              <React.Fragment />
            )}

            {isLoading ? (
              loadingColumns.map((value, index) => {
                return (
                  <StyledTableRow
                    key={index}
                    className={classes.tableBodyContainer}
                  >
                    {columOrderToShow.map((colum, index) => {
                      return (
                        <StyledTableCell
                          sx={{ minWidth: 250 }}
                          className={classes.tableBodyContent}
                          key={index}
                          component="th"
                          scope="row"
                        >
                          <Gradient
                            className={
                              index != 0 && index != 1 ? classes.autoMargin : ""
                            }
                          />
                        </StyledTableCell>
                      )
                    })}
                    {business == 0 && (
                      <StyledTableCell
                        sx={{ minWidth: 250 }}
                        className={classes.tableBodyContent}
                        key={index}
                        component="th"
                        scope="row"
                      >
                        <Gradient
                          className={
                            index != 0 && index != 1 ? classes.autoMargin : ""
                          }
                        />
                      </StyledTableCell>
                    )}
                  </StyledTableRow>
                )
              })
            ) : (
              <React.Fragment />
            )}
            {!isLoading ? (
              stableSort(filteredCampaignList, getComparator(order, orderBy))
                .map((campaign, index) => {
                  return (
                    <StyledTableRow key={index}>
                      <StyledTableCell
                        component="th"
                        scope="row"
                        sx={{
                          textAlign: "left",
                          paddingLeft: "calc(5.763vw) !important",
                        }}
                      >
                        {campaign.date}
                      </StyledTableCell>
                      {business == 0 && (
                        <StyledTableCell
                          component="th"
                          scope="row"
                          align="center"
                          sx={{ textAlign: "left" }}
                        >
                          {campaign.business_name}
                        </StyledTableCell>
                      )}
                      <StyledTableCell
                        component="th"
                        scope="row"
                        align="center"
                        sx={{ textAlign: "left" }}
                      >
                        {campaign.product_nombre}
                      </StyledTableCell>
                      <StyledTableCell
                        component="th"
                        scope="row"
                        align="center"
                      >
                        {campaign.solicitados}
                      </StyledTableCell>
                      <StyledTableCell
                        component="th"
                        scope="row"
                        align="center"
                      >
                        {campaign.enviados}
                      </StyledTableCell>
                      <StyledTableCell
                        component="th"
                        scope="row"
                        align="center"
                      >
                        {campaign.fallidos}
                      </StyledTableCell>
                    </StyledTableRow>
                  )
                })
            ) : (
              <React.Fragment />
            )}
            {filteredCampaignList.length === 0 && onLoad === false && (
              <StyledTableRow>
                <TableCell
                  colSpan={5}
                  sx={{
                    background: "#FFFFFF",
                    textAlign: "center",
                    fontSize: 20,
                    fontFamily: "Ubuntu",
                    fontStyle: "normal",
                    fontWeight: 400,
                    color: "#00182F",
                    lineHeight: "24px",
                    letterSpacing: "0.15px",
                  }}
                >
                  <Grid
                    container
                    direction="column"
                    sx={{ minHeight: "35vh" }}
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Grid item>
                      <Typography sx={{ color: "#CACCDC", fontSize: "25px" }}>
                        {`No hay resultados que mostrar `}
                      </Typography>
                    </Grid>
                  </Grid>
                </TableCell>
              </StyledTableRow>
            )}
          </TableBody>
        </Table>
        <ThemeProvider theme={theme}>
          <TablePagination
            component="div"
            rowsPerPageOptions={[5, 10, 15]}
            count={totalElements}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            labelRowsPerPage={
              <div
                style={{ marginRight: "-9px" }}
                className={classes.paginationLabel}
              >
                {`Páginas:`}
              </div>
            }
            labelDisplayedRows={({ from, to, count }) => (
              <div
                className={classes.paginationLabel}
              >{`${from}-${to} de ${count}`}</div>
            )}
            onRowsPerPageChange={handleChangeRowsPerPage}
            nextIconButtonProps={{
              sx: {
                color: "rgba(115, 115, 115, 1)",
              },
            }}
            backIconButtonProps={{
              sx: {
                color: "rgba(115, 115, 115, 1)",
              },
            }}
            SelectProps={{ inputProps: { sx: { paddingTop: "5px" } } }}
            sx={{
              marginTop: "5px",
              marginBottom: "5px",
              marginRight: "26px",
              color: "rgba(115, 115, 115, 1)",
            }}
          />
        </ThemeProvider>
      </TableContainer>
      <StatisticsFilter
        open={showFilter}
        setOpen={(open) => {
          setShowFilter(open)
        }}
        action={({ initDate, limitDate }) => {
          setSearchRange({
            initDate: initDate.format("YYYY-MM-DD"),
            limitDate: limitDate.format("YYYY-MM-DD"),
          })
        }}
      />
    </React.Fragment>
  )
}

export default Statistics
